export const AUDIO_FREQUENCIES = {
  LOW: {
    comparison: 220, // Lower A3 note
    swap: 440,      // A4 note
    found: 880      // A5 note
  },
  MEDIUM: {
    comparison: 330, // E4 note
    swap: 660,      // E5 note
    found: 990      // B5 note
  },
  HIGH: {
    comparison: 440, // A4 note
    swap: 880,      // A5 note
    found: 1320     // E6 note
  }
}; 